import { css } from '@emotion/css';

export const wrapperStyle = css`
  max-width: 1200px;
`;
